import type { FC } from "react";
import { DashboardCardSlot } from "web_myplann/Dashboard/Components/DashboardCardSlot";
import { DashboardCardV2Content } from "web_myplann/Dashboard/Components/DashboardCardV2Content";
import type { AnimationDirection } from "web_myplann/Dashboard/Hooks/useDashboardAnimation";
import { useDashboardCardSlots } from "web_myplann/Dashboard/Hooks/useDashboardCardSlots";
import type { DashboardType } from "web_myplann/Dashboard/Types/DashboardType";

type Props = {
	dashboard: DashboardType;
	direction: AnimationDirection;
	navigateToDashboardDetail?: () => void;
	onTooltipToggle?: (open: boolean) => void;
};

const SLOT_INDEXES = [0, 1] as const;

export const DashboardCardSlider: FC<Props> = ({
	dashboard,
	direction,
	navigateToDashboardDetail,
	onTooltipToggle,
}) => {
	const { slots, frontSlot, isEntering, getSlotTransform } =
		useDashboardCardSlots(dashboard, direction);

	return (
		<>
			{SLOT_INDEXES.map((slotIndex) => (
				<DashboardCardSlot
					key={slotIndex}
					transform={getSlotTransform(slotIndex)}
					isAnimated={!isEntering}
					isFront={slotIndex === frontSlot}
				>
					<DashboardCardV2Content
						dashboardData={slots[slotIndex]}
						navigateToDashboardDetail={navigateToDashboardDetail}
						onTooltipToggle={
							slotIndex === frontSlot ? onTooltipToggle : undefined
						}
					/>
				</DashboardCardSlot>
			))}
		</>
	);
};
